import axios from "axios";
import { useEffect, useState } from "react";

export default function ScoreCard(props) {
    const id = localStorage.getItem("candidateId");

    const [data, setData] = useState({fullname: "", description: "",score: "",createdOn: "",course: {name: "",},});

    function getData(id) {
        if(id===null){return}
        axios.get(`${process.env.REACT_APP_BASE_URL}api/candidate/open/getCandidate/${id}`)
        .then((result) => setData(result.data))
        .catch((err) => console.log(err));
    }
    useEffect(() => getData(id), [id]);

    return (
        <div className="score-page">
            <div className="container py-5">
                <div className="score-card">

                    {/* Header */}
                    <div className="score-header">
                        <button
                            className="close-btn"
                            onClick={() => {props.event(false)}}
                            aria-label="Close"
                        >
                            ×
                        </button>

                        <div className="score-icon">
                            🏆
                        </div>

                        <h2>Score Card</h2>
                        <p>Your quiz performance summary</p>
                    </div>

                    {/* Score */}
                    <div className="score-highlight">
                        <span className="score-label">Your Score</span>
                        <span className="score-value">
                            {data.score || "0/0"}
                        </span>
                    </div>

                    {/* Details */}
                    <div className="details-container">

                        <div className="detail-item">
                            <div className="detail-icon">👤</div>
                            <div>
                                <span className="detail-label">Full Name</span>
                                <h6>{data.fullname || "N/A"}</h6>
                            </div>
                        </div>

                        <div className="detail-item">
                            <div className="detail-icon">📚</div>
                            <div>
                                <span className="detail-label">Course</span>
                                <h6>{data.course?.name || "N/A"}</h6>
                            </div>
                        </div>

                        <div className="detail-item">
                            <div className="detail-icon">📝</div>
                            <div>
                                <span className="detail-label">Description</span>
                                <h6>{data.description || "N/A"}</h6>
                            </div>
                        </div>

                        <div className="detail-item">
                            <div className="detail-icon">📅</div>
                            <div>
                                <span className="detail-label">Date</span>
                                <h6>{data.createdOn || "N/A"}</h6>
                            </div>
                        </div>

                    </div>

                    {/* Footer */}
                    <div className="score-footer">
                        <button
                        className="btn continue-btn"
                        onClick={() =>
                        {localStorage.removeItem("candidateId");localStorage.setItem("resultView","false");window.location.href="/quiz"}}
                        >
                        Take Another Quiz →
                        </button>
                    </div>

                </div>
            </div>

            {/* Component CSS */}
            <style>{`
                .score-page {
                    height: 100vh;
                    background: linear-gradient(#a0d2eb,#e5eaf5);
                    display: flex;
                    align-items: center;
                    overflow:scroll;
                }

                .score-card {
                    max-width: 700px;
                    margin: auto;
                    background: rgba(255, 255, 255, 0.95);
                    border-radius: 24px;
                    overflow: hidden;
                    box-shadow: 0 20px 60px rgba(30, 41, 59, 0.15);
                    border: 1px solid rgba(255, 255, 255, 0.8);
                }

                .score-header {
                    position: relative;
                    text-align: center;
                    padding: 40px 30px 30px;
                    background: linear-gradient(#a0d2eb);
                    color: white;
                }

                .score-header h2 {
                    margin: 15px 0 5px;
                    font-weight: 700;
                    letter-spacing: 0.3px;
                }

                .score-header p {
                    margin: 0;
                    opacity: 0.85;
                    font-size: 14px;
                }

                .score-icon {
                    width: 65px;
                    height: 65px;
                    margin: auto;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: rgba(255, 255, 255, 0.18);
                    border-radius: 50%;
                    font-size: 30px;
                    backdrop-filter: blur(8px);
                }

                .close-btn {
                    position: absolute;
                    top: 18px;
                    right: 20px;
                    width: 38px;
                    height: 38px;
                    border: none;
                    border-radius: 50%;
                    background: rgba(255, 255, 255, 0.18);
                    color: white;
                    font-size: 25px;
                    line-height: 1;
                    cursor: pointer;
                    transition: 0.25s ease;
                }

                .close-btn:hover {
                    background: rgba(255, 255, 255, 0.3);
                    transform: rotate(90deg);
                }

                .score-highlight {
                    margin: -1px 30px 25px;
                    padding: 22px;
                    border-radius: 16px;
                    background: white;
                    box-shadow: 0 10px 30px rgba(79, 70, 229, 0.12);
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    position: relative;
                }

                .score-label {
                    color: #64748b;
                    font-size: 15px;
                    font-weight: 600;
                }

                .score-value {
                    font-size: 34px;
                    font-weight: 800;
                    color: rgb(74, 114, 188);
                }

                .details-container {
                    padding: 0 30px;
                }

                .detail-item {
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    padding: 18px 0;
                    border-bottom: 1px solid #e5e7eb;
                }

                .detail-item:last-child {
                    border-bottom: none;
                }

                .detail-icon {
                    min-width: 45px;
                    height: 45px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background: #eef2ff;
                    border-radius: 12px;
                    font-size: 20px;
                }

                .detail-label {
                    display: block;
                    color: #94a3b8;
                    font-size: 12px;
                    font-weight: 600;
                    text-transform: uppercase;
                    letter-spacing: 0.7px;
                    margin-bottom: 4px;
                }

                .detail-item h6 {
                    margin: 0;
                    color: #1e293b;
                    font-size: 15px;
                    font-weight: 600;
                    word-break: break-word;
                }

                .score-footer {
                    padding: 25px 30px 30px;
                    text-align: center;
                }

                .continue-btn {
                    width: 100%;
                    border: none;
                    border-radius: 12px;
                    padding: 13px 20px;
                    color: white;
                    font-weight: 600;
                    background: rgb(74, 114, 188);
                    box-shadow: 0 8px 20px rgba(79, 70, 229, 0.25);
                    transition: all 0.25s ease;
                }

                .continue-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 12px 25px rgba(79, 70, 229, 0.35);
                }

                @media (max-width: 576px) {
                    .score-page {
                        align-items: flex-start;
                    }

                    .container {
                        padding: 20px 12px !important;
                    }

                    .score-card {
                        border-radius: 18px;
                    }

                    .score-header {
                        padding: 32px 20px 25px;
                    }

                    .score-highlight {
                        margin-left: 18px;
                        margin-right: 18px;
                    }

                    .details-container {
                        padding: 0 20px;
                    }

                    .score-footer {
                        padding: 20px;
                    }

                    .score-value {
                        font-size: 28px;
                    }
                }
            `}</style>
        </div>
    );
}
